import { useLayoutEffect } from 'react';
import { useGetCastRelationships } from '../../../domains/scene/ui/hooks/useGetCastRelationships';
import { hasCastRelationship } from '../utils/getCastRelationshipId';
import saveData from '../../../utils/saveData';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';

export function useHasSceneCastRelationship(): boolean {
  const hasStored = hasCastRelationship();
  const { data: castRelationships } = useGetCastRelationships({
    page: 1,
    perPage: 1,
    enabled: !hasStored
  });

  useLayoutEffect(() => {
    if (castRelationships && castRelationships.length > 0 && !hasCastRelationship()) {
      saveData(
        LOCAL_STORAGE_KEYS.CURRENT_CAST_RELATIONSHIP_ID,
        castRelationships[0].castRelationshipId
      );
    }
  }, [castRelationships]);

  return hasStored || (castRelationships?.length ?? 0) > 0;
}
